import { createIconSetFromIcoMoon } from '@expo/vector-icons';

const XarageIcon = createIconSetFromIcoMoon(
    require('../../../../../assets/icomoon/selection.json'),
    'IcoMoon',
    'xarage.ttf'
);

export default XarageIcon;